<audio #audioRef autoplay [muted]="isLocal"></audio>
<div
  #videoContainerRef
  class="media-container"
  [class.d-none]="!mediaStatus?.cameraEnabled && !isScreenSharing"
></div>
@if (!mediaStatus?.cameraEnabled && !isScreenSharing) {
<div class="participant-placeholder" [class.bg-dark]="!isLocal">
  <atx-avatar
    [fullName]="contact?.displayName"
    [image]="contact?.imageLink"
    size="xxl"
  ></atx-avatar>
</div>
}
